"use client";

import React from "react";

export interface AtrEpilogueBlockProps {
    tag?: string;
    title?: string;
    description?: string;
    footerText?: string;
}

export default function AtrEpilogueBlock({
    tag = "// Project Epilogue",
    title = "High-fidelity digital twin solutions",
    description = "Examine how our system interfaces with Unity to reconstruct commercial flight events with absolute, verifiable telemetry fidelity.",
    footerText = "Built in Unity • Processes flight data recorder parameter logs"
}: AtrEpilogueBlockProps) {
    return (
        <section className="py-32 px-6 md:px-12 lg:px-24 bg-[#0C0D0E] relative overflow-hidden w-full" data-header-theme="light">
            <div className="absolute inset-0 bg-[radial-gradient(#00ff6603_1px,transparent_1px)] [background-size:24px_24px] pointer-events-none" />
            <div className="container mx-auto text-center relative z-10">
                <div className="max-w-2xl mx-auto space-y-6">
                    {tag && (
                        <span className="text-[10px] font-mono uppercase tracking-widest text-[#00FF66] block">
                            {tag}
                        </span>
                    )}
                    <h2 className="font-cormorant font-serif text-4xl md:text-6xl font-light text-white leading-tight">
                        {title}
                    </h2>
                    {description && (
                        <p className="text-white/60 text-sm md:text-base leading-relaxed max-w-md mx-auto font-sans font-light">
                            {description}
                        </p>
                    )}
                    {footerText && (
                        <div className="text-[9px] font-mono text-white/30 pt-6 uppercase tracking-widest">
                            {footerText}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}
